import React, {useEffect, useRef, useState} from "react";
import classNames from "classnames";
import styles from "./UIMessageInput.module.scss";
import {Mention, MentionsInput} from "react-mentions";

//@ts-ignore
// import { HighlightWithinTextarea } from 'react-highlight-within-textarea'

// import $ from "jquery";

const MemberMention = (props: any) => {
  const { image, name } = props;
  return (
    <div style={{ display: "inline-flex", alignItems: "center" }}>
      <div
        style={{
          width: 30,
          height: 30,
          backgroundImage: `url(${image})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          marginRight: 10,
        }}
      />
      <div>{name}</div>
    </div>
  );
};

const UIMessageInput = (props: any) => {
  const { members, value } = props;
  const [inputValue, setInputValue]: any = useState("");
  let messageRef: any = useRef(null);
  let refInputChat: any = useRef(null);
  const [msgValue, setMsgValue] = useState<string>("");
  const [users, setUsers] = useState<any>([]);

  // useEffect(() => {
  //   // refInputChat.current.focus();
  //   console.log("refInputChat : ", refInputChat);
  //   if (!checkEmpty(refInputChat)) refInputChat.current.focus();
  //
  // }, []);

  const onChange = async (e: any) => {
    if (props.maxlength && (e.target?.value || "").length > props.maxlength) {
      if (props.onMaxLengthExceed instanceof Function)
        props.onMaxLengthExceed();
      return;
    }

    setInputValue(e.target.value);
    if (props.onChange instanceof Function) props.onChange(e);
    if ((e.target.value || "").length === 0)
      e.target.style.height = props.minHeight + "px";
    if (props.multiline === true) {
      if (props.autoHeight === true) {
        e.target.style.height = props.minHeight + "px";
        if (e.target.scrollHeight <= props.maxHeight)
          e.target.style.height = e.target.scrollHeight + "px";
        else e.target.style.height = props.maxHeight + "px";
      }
    }
  };

  const getFullName = (user: any) => {
    return `${user?.firstname} ${user?.lastname ? user?.lastname : ""}`;
  };

  useEffect(() => {
    let convertMembers = []
    for (let i in members) {
      if (props.currentUserId === members[i]?.user?.id) continue;
      if (!members[i]?.user?.id || !members[i]?.user?.firstname) continue;
      convertMembers.push({
        id: members[i]?.user?.id,
        username: members[i]?.user?.username,
        display: members[i]?.user?.firstname,
        firstname: members[i]?.user?.firstname,
        lastname: members[i]?.user?.lastname,
        fullName: members[i]?.user?.firstname + " " + members[i]?.user?.lastname,
        imageProfileURL: members[i]?.user?.imageProfileURL
      })
    }
    setUsers(convertMembers)
  }, [members])

  useEffect(() => {
    if (props.autofocus === true) messageRef.current.focus();
    if (messageRef.current) {
      //@ts-ignore
      messageRef.current.onChange = onChange.bind(this);
      props.inputRef(messageRef.current);
    }

  }, [messageRef]);

  useEffect(()=>{
    let highlight: any = [];
    members?.map((member: any, idx: any) => {
      highlight.push("@"+member?.user?.firstname);
      highlight.push(member?.user?.lastname);
      highlight.push("@"+member?.user?.firstname+" "+member?.user?.lastname);
    })
    // console.log("highlight: ", highlight);

    //@ts-ignore
    $('#textArea').highlightWithinTextarea({
      highlight: highlight
    });
  },[members]);

  useEffect(()=>{
    //@ts-ignore
    $('#textArea').highlightWithinTextarea('update');
  },[value]);

  const handleChange = (e: any) => {
    console.log("e", e.target.value)
    setMsgValue(e.target.value);
  }

  const displayTransform = (id: string, display: string) => {
    return `@${display}`
  }

  const renderSuggestion = (entry: any, search: any, highlightedDisplay:any, index:any, focused:any) => {
    // return users.map((user: any, index: number) => {
    return <div style={{ display: "flex", justifyContent: "left", alignItems: "center", zIndex: 9999 }}>
      <div
          style={{
            width: "30px",
            height: "30px",
            // borderRadius: "50%",
            backgroundColor: "rgb(184,184,184)",
            backgroundPosition: "0px center",
            backgroundImage: `url(${entry?.imageProfileURL})`,
            backgroundSize: "cover",
            margin: ".5rem"
          }} />

      <span>
                        {entry.display}
                    </span>
    </div>
    // })
  }

  return (
    < div
      className={classNames(
        styles.ztcContainerInput,
        "chat-message",
        styles.ztcContainerInputChat
      )}
    >
      {props.leftButtons && (
        <div className={styles.ztcInputButtonsLeft}>{props.leftButtons}</div>
      )}
      {/* <textarea
        id={props.id}
        ref={messageRef}
        //@ts-ignore
        type={props.type}
        className={classNames("ztcInput", styles.ztcInputTextarea)}
        placeholder={props.placeholder}
        value={inputValue}
        style={props.inputStyle}
        //@ts-ignore
        onChange={onChange.bind(this)}
        onClick={props.onClick}
        onCopy={props.onCopy}
        onCut={props.onCut}
        onPaste={props.onPaste}
        onBlur={props.onBlur}
        onFocus={props.onFocus}
        onSelect={props.onSelect}
        onSubmit={props.onSubmit}
        onReset={props.onReset}
        onKeyDown={props.onKeyDown}
        onKeyPress={props.onKeyPress}
        onKeyUp={props.onKeyUp}
      /> */}
      {/* <HighlightWithinTextarea
        value={value}
        highlight="aaa"
      /> */}
      <MentionsInput
          value={value}
          onChange={props.onChange}
          placeholder="Aa"
          onKeyPress={props.onKeyPress}
            onSelect={props.onSelect}
          // ref={refInputChat}
          className={styles.mentionOverride}
          style={
            {
              suggestions: {
                zIndex: 99999,
                list: {
                  maxHeight: 256,
                  // width: 128,
                  overflow: 'auto',
                  position: 'absolute',
                  bottom: 20,
                  zIndex: 99999,
                  backgroundColor: 'white',
                },
                item: {
                  zIndex: 99999,
                  padding: '0 5px',
                  // borderBottom: '1px solid rgba(0,0,0,0.15)',
                  '&focused': {
                    backgroundColor: 'rgba(0,0,0,.1)',
                  },
                },
              }
            }
          }
      >
        <Mention
            trigger="@"
            markup="!--!@!__display__;__id__!!--!"
            // markup="@[__display__](__id__)"
            data={users}
            displayTransform={displayTransform}
            renderSuggestion={renderSuggestion}
            appendSpaceOnAdd
            // className={styles.mentionOverride}
            style={{
              backgroundColor: '#a3daff',
              borderRadius: 2,
            }}
        />
      </MentionsInput>
      {/*<Mentions*/}
      {/*  id="textArea"*/}
      {/*  ref={refInputChat}*/}
      {/*  className={styles.mentionOverride}*/}
      {/*  placement="top"*/}
      {/*  placeholder="Aa"*/}
      {/*  value={value}*/}
      {/*  onChange={props.onChange}*/}
      {/*  onKeyPress={props.onKeyPress}*/}
      {/*  split={" "}*/}
      {/*  onSelect={props.onSelect}*/}
      {/*>*/}
      {/*  {members?.map((member: any, idx: any) => {*/}
      {/*    if (props.currentUserId !== member?.user?.id) {*/}
      {/*      return (*/}
      {/*        <Option value={`${member?.user?.firstname}${member?.user?.lastname ? " "+member?.user?.lastname : ""}`} key={idx}>*/}
      {/*          <MemberMention*/}
      {/*            image={member?.user?.imageProfileURL}*/}
      {/*            name={getFullName(member?.user)}*/}
      {/*          />*/}
      {/*        </Option>*/}
      {/*      );*/}
      {/*    }*/}
      {/*  })}*/}
      {/*</Mentions>*/}
      

      {props.rightButtons && (
        <div className={styles.ztcInputButtons}>{props.rightButtons}</div>
      )}
    </div>
  );
};

export default UIMessageInput;
